if (!customElements.get('lux-carousel')) {
  customElements.define('lux-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lux-track');
      this.dots = this.querySelector('.lux-dots');
      if (!this.track || !this.dots) return;
      this.build();
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.ro = new ResizeObserver(() => this.build());
      this.ro.observe(this.track);
    }
    disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
    build() {
      const w = this.track.clientWidth || 1;
      const n = Math.max(1, Math.ceil((this.track.scrollWidth - 4) / w));
      if (n === this.count) return;
      this.count = n;
      this.dots.innerHTML = '';
      this.dots.hidden = n < 2;
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' }));
        this.dots.appendChild(b);
      }
      this.sync();
    }
    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      let i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      if (max > 0 && this.track.scrollLeft >= max - 4) i = this.count - 1;
      Array.from(this.dots.children).forEach((b, j) => b.setAttribute('aria-current', j === i ? 'true' : 'false'));
    }
  });
  customElements.define('lux-pricing', class extends HTMLElement {
    connectedCallback() {
      const b = this.querySelector('[data-toggle]');
      if (!b) return;
      b.addEventListener('click', () => {
        const yearly = this.dataset.period !== 'yearly';
        this.dataset.period = yearly ? 'yearly' : 'monthly';
        b.setAttribute('aria-checked', String(yearly));
      });
    }
  });
}
